import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed } from "vue";
  import { isValidFileSize, isXlsxType } from "@/helpers/fileUpload";
  import { useStore } from "vuex";
  import { useToast } from "vue-toastification";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminSettings',
  setup(__props, { expose: __expose }) {
  __expose();

  const store = useStore();
  const templateFile = ref<File | null>(null);
  const templateLeadsFile = ref<File | null>(null);
  const toast = useToast();
  const templateDownloadLink = ref<string | null>(null);
  const templateLeadsDownloadLink = ref<string | null>(null);

  onMounted(() => {
    getTemplateLink();
    getTemplateLeadsLink();
  });

  function getTemplateLink() {
    store.dispatch("lot/downloadXlsxTemplate").then((res) => {
      templateDownloadLink.value = res.data.message ? null : res.data;
    });
  }
  function getTemplateLeadsLink() {
    store.dispatch("contact/downloadLeadsTemplate").then((res) => {
      templateLeadsDownloadLink.value = res.data.message ? null : res.data;
    });
  }
  function selectFile(e: any, type = "") {
    if (!e.target.files.length) {
      return;
    }

    const selectedFile = e.target.files[0];

    if (!isXlsxType(selectedFile) || !isValidFileSize(selectedFile)) {
      return;
    }

    if (type === "leads") {
      templateLeadsFile.value = selectedFile;
    } else {
      templateFile.value = selectedFile;
    }
  }
  function uploadTemplate(type = "") {
    const data = new FormData();
    const file =
      type === "leads" ? templateLeadsFile.value : templateFile.value;

    data.append("file", file as File);
    const action =
      type === "leads"
        ? "contact/uploadLeadsTemplate"
        : "lot/uploadXlsxTemplate";

    store.dispatch(action, data).then(() => {
      type === "leads" ? getTemplateLeadsLink() : getTemplateLink();
      toast.success("File successfully uploaded");
    });
  }
  function deleteTemplate(type = "") {
    const action =
      type === "leads"
        ? "contact/deleteLeadsTemplate"
        : "lot/deleteXlsxTemplate";

    store.dispatch(action).then(() => {
      type === "leads" ? getTemplateLeadsLink() : getTemplateLink();
      toast.success("File successfully deleted");
    });
  }

const __returned__ = { store, templateFile, templateLeadsFile, toast, templateDownloadLink, templateLeadsDownloadLink, getTemplateLink, getTemplateLeadsLink, selectFile, uploadTemplate, deleteTemplate, ref, onMounted, computed, get isValidFileSize() { return isValidFileSize }, get isXlsxType() { return isXlsxType }, get useStore() { return useStore }, get useToast() { return useToast } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})